import React from "react";
import { graphql } from "gatsby";
import VideoEmbed, { Type } from "@unum/video-embed";
import { ExternalVideoFragmentFragment } from "../../graphql-types";

type Props = {
  data: ExternalVideoFragmentFragment;
  className?: string;
  isInline?: boolean;
  type?: Type;
};

const ExternalVideo = ({ data, className, isInline, type }: Props) => {
  const { url, preview_image } = data.elements;
  const { name } = data.system;

  return (
    // @todo: Video content-type doesn't have the title yet. Using the internal
    // kontent name for now.
    <VideoEmbed
      className={className}
      videoUrl={url.value}
      accessibilityLabel={name}
      isInline={isInline}
      fallback={preview_image?.value}
      type={type}
    />
  );
};

export default ExternalVideo;

export const query = graphql`
  fragment ExternalVideoElementsFragment on kontent_item_external_video {
    elements {
      url {
        value
      }
      preview_image {
        value
      }
    }
  }

  fragment ExternalVideoFragment on kontent_item_external_video {
    __typename
    id
    system {
      name
    }
    ...ExternalVideoElementsFragment
  }
`;
